// extracted by mini-css-extract-plugin
export default {"slider":"QuickTransfer_slider__Y449c"};